<div [ngClass]="cssTrida">
	<div class="subheading__content">
		<span>{{ klicTextu | lokalizace }}</span>
	</div>
	<mat-divider></mat-divider>
</div>
